import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Combobox from '@salesforce/design-system-react/lib/components/combobox';

class EmailComboBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      value: '',
      errorText: ''
    };
  }

  textChanged(value) {
    this.setState({
      options: [{ id: '0', label: value }],
      value,
      errorText: value ? this.state.errorText : ''
    });
  }

  addItem(selection) {
    if (selection && this.validateEmail(selection) && this.props.onChange) {
      this.setState({ options: [], value: '' });
      this.props.onChange([
        ...this.props.emails,
        { id: selection, label: selection }
      ]);
    }
  }

  removeItem(selection) {
    const selectedEmails = this.props.emails.filter(item =>
      selection.includes(item)
    );

    if (this.props.onChange) {
      this.props.onChange(selectedEmails);
    }
  }

  isInvalidEmailFormat(email) {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(email);
  }

  isDuplicateEmail(email) {
    return this.props.emails.find(item => item.label === email) !== undefined;
  }

  validateEmail(email) {
    let isValid = false;
    if (this.isInvalidEmailFormat(email)) {
      this.setState({ errorText: this.props.invalidErrorText });
    } else if (this.isDuplicateEmail(email)) {
      this.setState({ errorText: this.props.duplicateErrorText });
    } else {
      this.setState({ errorText: '' });
      isValid = true;
    }
    return isValid;
  }

  render() {
    return (
      <div>
        <Combobox
          id={`${this.props.id}-combobox`}
          events={{
            onChange: (event, { value }) => {
              this.textChanged(value);
            },
            onRequestRemoveSelectedOption: (event, data) => {
              this.removeItem(data.selection);
            },
            onSubmit: (event, { value }) => {
              this.addItem(value);
            },
            onBlur: () => {
              this.addItem(this.state.value);
            }
          }}
          labels={{
            label: this.props.label,
            placeholder: this.props.placeholder
          }}
          value={this.state.value}
          multiple
          options={this.state.options}
          selection={this.props.emails}
          variant="inline-listbox"
          isOpen={false}
        />

        {this.state.errorText && (
          <div className="slds-has-error">
            <div className="slds-form-element__help">
              {this.state.errorText}
            </div>
          </div>
        )}
      </div>
    );
  }
}

EmailComboBox.propTypes = {
  id: PropTypes.string,
  emails: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  duplicateErrorText: PropTypes.string.isRequired,
  invalidErrorText: PropTypes.string.isRequired
};

export default EmailComboBox;
